import {Auth} from 'aws-amplify';

export const getToken = async() => {
    try{ 
        const session = await Auth.currentSession();
        return session.getIdToken().getJwtToken().trim()
    } catch(err){
        throw new Error(`Failed to fetch token due to: ${err}`)
    }
}